import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=da7a9e04&scoped=true&"
import script from "./sendMessage.vue?vue&type=script&lang=ts&"
export * from "./sendMessage.vue?vue&type=script&lang=ts&"
import style0 from "./sendMessage.vue?vue&type=style&index=0&id=da7a9e04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7a9e04",
  null
  
)

export default component.exports